import React from 'react'

const PanelControlDelete = ({ onClick, disabled, disabledStyle='panel-header-control-disabled', enabledStyle='panel-header-control-delete', glyphicon='glyphicon-trash', tip=null}) =>
{
	const onLocalClick = () =>
	{
		if ( onClick != null )
		{
			onClick() ;
		}
	}

	const renderedComponent = () =>
	{
        let options = { key: 'outerDelete', className: 'panel-header-control ' + disabledStyle + ' glyphicon ' + glyphicon } ;

        if ( disabled === true )
		{
            return (
				<div { ...options }>
					<div className = 'deleteIcon' />
				</div>
			)
		}
		else
		{
			options.onClick = onLocalClick ;

			if ( tip != null )
			{
				options['data-tip'] = tip ;
			}

			options.className = 'panel-header-control ' + enabledStyle + ' glyphicon ' + glyphicon ;

            return (
				<span { ...options }>
					<span data-tip='Tip' className='deleteIcon'></span>
				</span>
			)
		}
	}
	
	return renderedComponent() ;
}

export default PanelControlDelete ;